// src/components/common/FilePreviewModal.js
import React from "react";
import { Modal, Button } from "react-bootstrap";

const FilePreviewModal = ({ show, handleClose, file }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header>
        <Modal.Title>Bill / Document Preview</Modal.Title>
        <Button variant="" className="btn-close" onClick={handleClose}></Button>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
        {file ? (
          file.type === "pdf" ? (
            <embed
              src={file.url}
              type="application/pdf"
              width="100%"
              height="600px"
              style={{ borderRadius: "5px" }}
            />
          ) : (
            <img
              src={file.url}
              alt="Preview"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "5px",
                display: "block",
              }}
            />
          )
        ) : (
          <p className="text-center text-muted">No document selected</p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilePreviewModal;
